import baseAPI from '@/api/base';
import { EditCustomFont, GetCustomFont } from '@/dtos/custom_font.dto';
import {
  DELETE_CUSTOM_FONT_URL,
  EDIT_CUSTOM_FONT_URL,
  GET_CUSTOM_FONT_URL,
  REGISTER_CUSTOM_FONT_URL,
} from '@/utils/urls';
import { AxiosResponse } from 'axios';

/* -------------------------------------------------------------------------
   Custom font transport. Mirrors `services/poster.ts`: the create call is
   multipart (the font file rides along as `file`), everything else is JSON.

   Served by `routes/custom_font.ts` in the backend, which stores the upload
   under the `documents/custom_fonts` prefix of the storage bucket.
   ------------------------------------------------------------------------- */
class CustomFont {
  static getCustomFonts = async (
    getCustomFont: GetCustomFont
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_CUSTOM_FONT_URL, {
      params: getCustomFont,
    });
    return response;
  };

  static registerCustomFont = async (
    formData: FormData
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(
      REGISTER_CUSTOM_FONT_URL,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response;
  };

  static editCustomFont = async (
    editCustomFont: EditCustomFont
  ): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_CUSTOM_FONT_URL, {
      ...editCustomFont,
    });
    return response;
  };

  static deleteCustomFont = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(
      `${DELETE_CUSTOM_FONT_URL}/${id}`
    );
    return response;
  };
}

export default CustomFont;
